export const CREATE_FEEDBACK = {
  BEGIN: 'CREATE_FEEDBACK_BEGIN',
  SUCCESS: 'CREATE_FEEDBACK_SUCCESS',
  FAILURE: 'CREATE_FEEDBACK_FAILURE'
}
